export const Task_FEED_VIEW_SET = 'Task_FEED_VIEW_SET';
export const TASK_SUMMERY_ID_SET = 'TASK_SUMMERY_ID_SET';
export const TASK_FILTER_SET = 'TASK_FILTER_SET';
export const TASK_TABLE_DATA_SET = 'TASK_TABLE_DATA_SET';
export const PLANOGRAM_TASK_DATA_SET = 'PLANOGRAM_TASK_DATA_SET';